export const DOC_MIME_TYPE = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/x-ole-storage"]
export const ZIP_MIME_TYPE = ["application/zip", "text/csv"]
export const XLS_MIME_TYPE = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
export const PPT_MIME_TYPE = ["application/vnd.ms-powerpoint"]
export const PDF_MIME_TYPE = ["application/pdf"]
export const VIDEO_MIME_TYPE = ["video/mp4", "video/x-flv", "video/x-matroska", "video/quicktime", "video/mpeg"]
export const IMG_MIME_TYPE = ["image/png", "image/jpg", "image/jpeg"]

export const mimeType = (str) => {
    if (str === 'application/ecr.parent') {
        return 'parent'
    } else if (str === 'application/ecr.leaf') {
        return 'leaf'
    } else if (PDF_MIME_TYPE.includes(str)) {
        return "pdf"
    } else if (IMG_MIME_TYPE.includes(str)) {
        return "img"
    } else if (XLS_MIME_TYPE.includes(str)) {
        return "xls"
    } else if (PPT_MIME_TYPE.includes(str)) {
        return "ppt"
    } else if (DOC_MIME_TYPE.includes(str)) {
        return "docx"
    } else if (VIDEO_MIME_TYPE.includes(str)) {
        return "img"
    } else if (ZIP_MIME_TYPE.includes(str)) {
        return "xls"
    } else {
        return "default"
    }
}

export const mimeTypeToString = (str) => {
    if (PDF_MIME_TYPE.includes(str)) {
        return "pdf"
    } else if (IMG_MIME_TYPE.includes(str)) {
        return "image"
    } else if (XLS_MIME_TYPE.includes(str)) {
        return "xls"
    } else if (PPT_MIME_TYPE.includes(str)) {
        return "ppt"
    } else if (DOC_MIME_TYPE.includes(str)) {
        return "doc"
    } else if (VIDEO_MIME_TYPE.includes(str)) {
        return "video"
    } else if (ZIP_MIME_TYPE.includes(str)) {
        return "zip"
    } else {
        return "default"
    }
}

export default mimeType()
